import React, { useState, useEffect } from "react";
// componentes
import {
  Table,
  Collapse,
  Card,
  CardBody,
  CardTitle,
  Button,
  Row,
} from "reactstrap";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import Pagination from "../../../components/Paginationv3";
import SearchFilters from "../../../components/SearchFilters";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import DeleteButton from "../../../components/Buttons/DeleteButton";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
import ModalNewSuperTela from "./ModalNewSuperTela";
import ModalEdidSuperTela from "./ModalEditSuperTela";
import ModalSurvey from "./Survey/ModalSurvey";
import SuperTela3 from "./SuperTela3";
// rotas
import { useLocation } from "react-router-dom";
// redux
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// hooks
import useDebounce from "../../../utils/hooks/useDebounce";
// services
import {
  getSuperScreen,
  deleteSuperScreen,
} from "../../../utils/services/superScreen";

function SuperTela(props) {
  // location
  const location = useLocation();
  const idEvent = location.state.idEvent;
  //pesquisa
  const [search, setSearch] = useState("");
  //modais
  const [modalNewSuperTela, setModalNewSuperTela] = useState(false);
  const [modalEditSuperTela, setModalEditSuperTela] = useState(false);
  const [modalSurvey, setModalSurvey] = useState(false);
  const [modalSuperTela3, setModalSuperTela3] = useState(false);
  //deletar super tela
  const [deleteData, setDeleteData] = useState({});
  const [confirmAlert, setConfirmAlert] = useState(false);
  const [successDlg, setSuccessDlg] = useState(false);
  const [deleteErrorMessage, setDeleteErrorMessage] = useState("");
  // editar
  const [editData, setEditData] = useState({});
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [countData, setCountData] = useState(0);
  const debouncedSearch = useDebounce(search, 300);
  //state de super tela
  const [superTelas, setSuperTelas] = useState([]);
  // id da supertela para as enquetes
  const [superScreenId, setSuperScreenId] = useState("");
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("name");
  // modal collapse
  const [isOpen, setIsOpen] = useState(false);
  const [idDashboard, setIdDashboard] = useState();
  // loading
  const [loading, setLoading] = useState(false);

  const columnsFilter = [
    { name: "Nome", value: "name", type: "text" },
    { name: "Canais", value: "channels", type: "text" },
    { name: "Chat", value: "chat", type: "boolean" },
    { name: "Super emoji", value: "emoji", type: "boolean" },
  ];

  // altera o filtro de busca ativo e limpa o texto pesquisado
  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  // inverte uma data no formato dd/mm/aaaa para aaaa-mm-dd
  const reverseDate = () => {
    const reverse = debouncedSearch
      .split("/")
      .reverse()
      .join("/")
      .replace(/\//g, "-");
    return reverse;
  };

  // formata o texto de busca conforme o tipo do filtro ativo
  function treatmentSearch() {
    if (
      columnsFilter.filter((item) => item.value === activeFilter)[0].type ===
      "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }

  // abre/fecha o modal de criação
  function toggleNewSuperTela() {
    setModalNewSuperTela(!modalNewSuperTela);
  }

  // abre/fecha o modal de edição
  function toggleEditSuperTela() {
    setModalEditSuperTela(!modalEditSuperTela);
  }

  // abre/fecha o modal de enquetes
  function toggleSurvey() {
    setModalSurvey(!modalSurvey);
  }

  // copia o link de transmissão para a área de transferência
  async function clipBoard(id) {
    await navigator.clipboard.writeText(
      "https://unhealthy-birds.surge.sh?transmissionKey=" + id,
    );
    toast.success("O link foi copiado para a área de transferência");
  }

  // busca a listagem de super telas
  function getAllSuperScreen() {
    setLoading(true);
    getSuperScreen(
      props.state.global_user_data.data.token,
      idEvent,
      currentIndex,
      itemsPerPage,
      treatmentSearch(),
      activeFilter,
    )
      .then((res) => {
        if (res.message === "transmissionByEvent") {
          setSuperTelas(res.findOneTransmissionData.data);
          setCountData(res.findOneTransmissionData.count);
        } else {
          toast.error("Erro ao buscar Super Telas.");
          setSuperTelas([]);
          setCountData(0);
        }
      })
      .catch((error) => {
        toast.error("Erro ao buscar Super Telas.");
        setSuperTelas([]);
        setCountData(0);
      })
      .finally(() => setLoading(false));
  }

  // deleta uma super tela
  async function funcDeleteFeed() {
    try {
      const res = await deleteSuperScreen(
        deleteData.id,
        props.state.global_user_data.data.token,
      );
      setConfirmAlert(false);
      if (res.message === "DELETED_TRANSMISSION") {
        setSuccessDlg(true);
      } else {
        setDeleteErrorMessage("Erro ao deletar Super Tela.");
      }
    } catch (error) {
      setConfirmAlert(false);
      setDeleteErrorMessage("Erro ao deletar Super Tela.");
    }
  }

  useEffect(() => {
    getAllSuperScreen();
  }, [currentIndex, itemsPerPage, debouncedSearch, activeFilter]);

  return (
    <>
      {modalNewSuperTela && (
        <ModalNewSuperTela
          isOpen={modalNewSuperTela}
          toggle={toggleNewSuperTela}
          idEvent={idEvent}
          getSuperScreen={getAllSuperScreen}
        />
      )}
      {modalEditSuperTela && (
        <ModalEdidSuperTela
          isOpen={modalEditSuperTela}
          toggle={toggleEditSuperTela}
          idEvent={idEvent}
          data={editData}
          getAllSuperScreen={getAllSuperScreen}
        />
      )}

      {modalSurvey && (
        <ModalSurvey
          isOpen={modalSurvey}
          toggle={toggleSurvey}
          idEvent={idEvent}
          idSuperScreen={superScreenId}
        />
      )}

      {modalSuperTela3 && (
        <SuperTela3
          isOpen={modalSuperTela3}
          toggle={() => setModalSuperTela3(!modalSuperTela3)}
          idDashboard={idDashboard}
          idEvent={idEvent}
        />
      )}

      {confirmAlert ? (
        <SweetAlert
          title={`Deseja deletar a Super Tela ${deleteData.name}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            funcDeleteFeed();
          }}
          onCancel={() => setConfirmAlert(false)}
        >
          Você não poderá reverter essa ação!
        </SweetAlert>
      ) : null}

      {successDlg ? (
        <SweetAlert
          success
          title="Sucesso"
          onConfirm={() => {
            getAllSuperScreen();
            setSuccessDlg(false);
          }}
        >
          Super Tela deletada com sucesso
        </SweetAlert>
      ) : null}

      {deleteErrorMessage && (
        <SweetAlert
          danger
          title="Erro"
          onConfirm={() => setDeleteErrorMessage("")}
        >
          {deleteErrorMessage}
        </SweetAlert>
      )}

      <Card>
        <CardBody>
          <CardTitle>Super Tela</CardTitle>
          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              margin: "10px 0",
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type="text"
                  value={search}
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>

            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type="text"
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                <ActionButtonRounded
                  title="Adicionar Super Tela"
                  onClick={() => setModalNewSuperTela(true)}
                  type="mobile"
                />
              </Collapse>
            </div>

            <div className="header-btns-container">
              <ActionButtonRounded
                title="Adicionar Super Tela"
                onClick={() => setModalNewSuperTela(true)}
              />
            </div>
          </div>

          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>Canais</th>
                  <th>Chat</th>
                  <th>Super emoji</th>
                  <th>Perguntas</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <LoadingSkelentonTable lines={10} cols={7} />
                ) : (
                  superTelas.length > 0 &&
                  superTelas.map((e) => (
                    <tr key={e.id}>
                      <td>{e.id}</td>
                      <td>{e.name}</td>
                      <td>
                        {e.channels.map((channel) => channel.name).join(", ")}
                      </td>
                      <td>{e.visibleChat ? "Sim" : "Não"}</td>
                      <td>{e.emojiActive ? "Sim" : "Não"}</td>
                      <td>{e.questions ? "Sim" : "Não"}</td>
                      <td>
                        <i
                          className="mdi mdi-form-select"
                          style={{
                            color: "blue",
                            fontSize: 17,
                            margin: "0 3px",
                            cursor: "pointer",
                          }}
                          title="Enquetes"
                          onClick={() => {
                            setSuperScreenId(e.id);
                            setModalSurvey(true);
                          }}
                        />
                        <i
                          className="mdi mdi-chart-areaspline"
                          style={{
                            color: "#e0e013",
                            fontSize: 17,
                            margin: "0 3px",
                            cursor: "pointer",
                          }}
                          title="Dashboard"
                          onClick={() => {
                            setIdDashboard({
                              transmissionId: e.id,
                              chatId: e.visibleChat ? e.chats[0].chatId : null,
                            });
                            setModalSuperTela3(true);
                          }}
                        />
                        <i
                          className="mdi mdi-content-copy"
                          style={{
                            color: "grey",
                            fontSize: 17,
                            margin: "0 3px",
                            cursor: "pointer",
                          }}
                          title="Copiar"
                          onClick={() => clipBoard(e.id)}
                        />
                        <i
                          className="mdi mdi-pencil"
                          style={{
                            color: "green",
                            fontSize: 17,
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setEditData(e);
                            setModalEditSuperTela(true);
                          }}
                          title="Editar"
                        />
                        <DeleteButton
                          onClick={() => {
                            setDeleteData(e);
                            setConfirmAlert(true);
                          }}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      {/* 
      Fornecer os 4 parametros obrigatórios;
      ** data - a array contendo as informações da tabela
      ** search - o state do termo de pesquisa
      ** currentIndex - posição atual do index
      ** setCurrentIndex - função para atualizar a posição atual do index
      */}
      <Pagination
        data={superTelas}
        search={search}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        countData={countData}
        maxItemPerPage={itemsPerPage}
        setMaxItemPerPage={setItemsPerPage}
        maxPageButtonsToShow={3}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(SuperTela);
